// OCT-7340: TreatyApp: User Management — add an Action History view of admin activity - Frontend : ashish.atwal@resolutionlife.com
// The "Action History" button (with a NEW badge) shown on the User Management
// page. It owns the drawer's open/close state and renders the ActionHistoryPanel.
// Only privileged administrators (canManageUsers — the same gate that protects
// the User Management page and the backend actionHistory query) see the button.
import { FC } from 'react';
import { Button, useDisclosure } from '@chakra-ui/react';
import { BiHistory } from 'react-icons/bi';

import { useAppConfig } from '../../context/app-config-context/app-config-context';
import { ActionHistoryPanel } from './action-history-panel';

export const ActionHistoryButton: FC = () => {
  const { canManageUsers } = useAppConfig();
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (!canManageUsers) {
    return null;
  }

  return (
    <>
      <Button
        onClick={onOpen}
        colorScheme="blue"
        variant="outline"
        leftIcon={<BiHistory />}
        data-testid="action-history-button"
      >
        Action History
      </Button>

      <ActionHistoryPanel isOpen={isOpen} onOpen={onOpen} onClose={onClose} />
    </>
  );
};
